const principles = [
  {
    no: '01',
    title: '尊重版权，正版优先',
    desc: '我们鼓励并引导用户通过正规渠道获取漫画内容，本站自身不提供盗版内容，只做追更收藏与更新提醒服务。',
  },
  {
    no: '02',
    title: '信息准确，更新及时',
    desc: '连载更新日期与话数均以作品官方公告为准，力求让追漫日历上的每条信息都准确、可靠、可追踪。',
  },
  {
    no: '03',
    title: '数据安全，进度不丢',
    desc: '你的收藏清单与阅读进度是你的宝贵资产。我们始终以高标准保障数据安全，让每一份追更记忆都稳妥保存。',
  },
  {
    no: '04',
    title: '体验克制，拒绝打扰',
    desc: '不做无意义的弹窗与干扰，所有提醒都围绕你的追更需要展开，让工具回归工具的本质。',
  },
];

export default function Principles() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-2xl text-center">
        <span className="text-sm font-semibold tracking-wide text-primary-600">内容原则</span>
        <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">我们始终坚守的底线</h2>
        <p className="mt-4 text-foreground-600">四条朴素的准则，贯穿我爱漫画网的内容与产品始终。</p>
      </div>

      <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2">
        {principles.map((p) => (
          <div
            key={p.no}
            className="flex gap-5 rounded-2xl border border-background-200/70 bg-background-50 p-6"
          >
            <span className="font-heading text-3xl text-primary-300">{p.no}</span>
            <div>
              <h3 className="text-lg font-bold text-foreground-950">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}